import firebase from "./index";

export function firebaseCreateUser(email, password) {
  return firebase.auth().createUserWithEmailAndPassword(email, password);
}

export function firebaseSignin(email, password) {
  return firebase.auth().signInWithEmailAndPassword(email, password);
}

export function firebaseSignout() {
  return firebase.auth().signOut();
}

export function firebaseAuthUser() {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        resolve(user);
      } else {
        resolve(null);
      }
    });
  });
}

export function firebaseCreateSignupToken(signupInfo) {
  return new Promise(async (resolve, reject) => {
    try {
      const newSignupRef = firebase.database().ref().child(`signup`).push();

      await newSignupRef.set(signupInfo);
      resolve(newSignupRef.key);
    } catch (error) {
      reject(error);
    }
  });
}

export function firebaseFetchOneSignupInfo(signupToken) {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref()
      .child(`signup`)
      .child(signupToken)
      .once("value")
      .then((snap) => {
        resolve(snap.val());
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function firebaseCreateNewUser(uid, newUser) {
  return firebase.database().ref("users").child(uid).set(newUser);
}
